const translations = {
	welcome: {
		page_title: "Bienvenue",
		title: "Bienvenue sur Wenimmo",
		description: "Configurez votre mot de passe afin d'acceder a la plateforme",
		placeholder: "Entrer l'e-mail",
		button: "Se connecter",
	},
	connect: {
		page_title: "Connection",
		title: "Bienvenue sur Wenimmo",
		description: "Configurez votre mot de passe afin d'acceder a la plateforme",
		label: "Mot de passe",
		placeholder: "Entrer le mot de passe",
		forgot_password: "Mot de passe oublié ?",
		button: "Se connecter",
	},
	pin_code_login: {
		page_title: "Connexion par code pin",
		title: "Vérification de votre identité",
		description:
			"Un code de sécurité à 6 chiffres a été envoyé sur votre boite mail afin de vérifier que vous en êtes bien le propriétaire.\n\nVeuillez renseigner ce code ci-dessous (vérifiez vos spams).",
	},
	request_pin_code: {
		label: "Code pin à 6 chiffres",
		send_pin_code: "Envoyer le code par mail",
		resend_pin_code_in: "Renvoyer un mail dans: ",
		initialize_password: {
			page_title: "Creation de compte",
			title: "Créer votre mot de passe",
			description:
				"Un code de sécurité à 6 chiffres a été envoyé sur votre boite mail afin de vérifier que vous en êtes bien le propriétaire.\n\nVeuillez renseigner ce code ci-dessous (vérifiez vos spams).",
		},
		forgotten_password: {
			page_title: "Mot de passe oublié",
			title: "Mot de passe oublié ?",
			description: "Afin de réinitialiser votre mot de passe, vous devez entrer un code pin à 6 chiffres envoyé dans votre boite mail.",
		},
	},
	reset_password: {
		create_password: "Créer un mot de passe",
		confirm_password: "Confirmer le mot de passe",
		enter_password: "Entrer votre mot de passe",
		requirements: "Au moins 12 caractères, une minuscule, une majuscule, un chiffre, un caractère spécial",
		initialize_password: {
			page_title: "Creation de compte",
			title: "Initialiser votre mot de passe",
			description: "Créer votre mot de passe",
			success_button: "S'enregister",
		},
		forgotten_password: {
			page_title: "Mot de passe oublié",
			title: "Réinitialiser le mot de passe",
			description: "Créer votre nouveau mot de passe",
			success_button: "Réinitialiser le mot de passe",
		},
	},
};

export default translations;
